import React from "react";
import "./myhealth.css";
function Myhealth() {
  const handleReadAllBlog = () => {
    window.location.href = "https://redcliffelabs.com/myhealth/";
  };
  return (
    <div className="containerMyhealth">
      <div className="display">
        <div className="mobile">
          {" "}
          <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/242d3d77-8e09-42e1-beb0-f71d18ed8591.png"></img>
        </div>
        <div className="side">
          <div className="leftside">
            <div className="container2">
              <div className="heading">
                <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b9c0f609-2faa-4224-a8fd-9c4e1e623efc.png" />
              </div>
              <div className="content">
                <span>
                  Myhealth is your one-stop destination to find answers to all
                  your <br />
                  health-related queries. My Health allows you to enlighten and{" "}
                  <br /> broaden your understanding about different health
                  topics, including <br /> your vital organs, your lifestyle,
                  your nutrition and much more{" "}
                </span>
              </div>
              <div className="btn">
                <button onClick={handleReadAllBlog} className="readbtn">
                  Read All Blogs
                </button>
              </div>
            </div>
          </div>
          <div className="rightside">
            <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/242d3d77-8e09-42e1-beb0-f71d18ed8591.png" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Myhealth;
